import ComponentName from '../../../constant/ComponentName';
import LanguageUtil from '../../../util/LanguageUtil';

const getExportImportComponentLabel = (component: ComponentName): string => {
  switch (component) {
    case ComponentName.TRANSACTION:
      return LanguageUtil.get({ id: 'common.label.channel', defaultMessage: 'Channel' });
    case ComponentName.CASE:
      return LanguageUtil.get({ id: 'common.label.transaction', defaultMessage: 'Transaction' });
    case ComponentName.STREAM:
      return LanguageUtil.get({ id: 'common.label.store', defaultMessage: 'Store' });
    case ComponentName.WATCHLIST_ALERT:
      return LanguageUtil.get({ id: 'common.label.watchlistAlert', defaultMessage: 'WatchlistAlert' });
    case ComponentName.AI_MODEL:
      return LanguageUtil.get({ id: 'common.label.mlopsU', defaultMessage: 'ML-OPS' });
    case ComponentName.ADMIN_AUDIT_LOG:
      return LanguageUtil.get({ id: 'common.label.adminAuditLog', defaultMessage: 'Admin Audit Log' });
    case ComponentName.LOGIN_AUDIT_LOG:
      return LanguageUtil.get({ id: 'common.label.loginAuditLog', defaultMessage: 'Login Audit Log' });
    case ComponentName.CUSTOM_LIST:
      return LanguageUtil.get({ id: 'common.label.customList', defaultMessage: 'Custom List' });
    default:
      return component;
  }
};

export default getExportImportComponentLabel;
